<template>
  <div class="dea-pager">
    <slot />
  </div>
</template>

<script>
/**
 *
 */
export default {
  name: "Pager",
};
</script>
